import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { UsersFakeData } from '@fake-db/users.data';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';


@Injectable({
  providedIn: 'root'
})
export class MasterService {
  private apiUrl = environment.apiUrl;
  public rows: any;
  public currentUser: any = JSON.parse(localStorage.getItem('currentUser') || '{}');
  private companyId = this.currentUser?.assignedCompany?.id || null;

  constructor(private _httpClient: HttpClient) {

  }

  // Get Departments
  getDepartments(): Observable<any> {
    let url = `${this.apiUrl}/companies/${this.companyId}/departments?status=true`;
    return this._httpClient.get<any>(url);
  }

  // Create Departments
  saveDepartments(data: any): Observable<any> {
    let url = `${this.apiUrl}/companies/${this.companyId}/departments`;
    return this._httpClient.post<any>(url, data);
  }

  // Update Departments
  updateDepartments(data: any, departmentId: any): Observable<any> {
    let url = `${this.apiUrl}/companies/${this.companyId}/departments/${departmentId}`;
    return this._httpClient.patch<any>(url, data);
  }


  getDashboards(): Observable<any> {
    let url = `${this.apiUrl}/companies/${this.companyId}/departments?status=true`;
    return this._httpClient.get<any>(url);
  }

  // Get Roles
  getRoles(): Observable<any> {
    let url = `${this.apiUrl}/companies/${this.companyId}/roles?status=true`;
    return this._httpClient.get<any>(url);
  }

  // Create Roles
  saveRoles(data: any): Observable<any> {
    let url = `${this.apiUrl}/companies/${this.companyId}/roles`;
    return this._httpClient.post<any>(url, data);
  }

  // Update Roles
  updateRoles(data: any, roleId: any): Observable<any> {
    let url = `${this.apiUrl}/companies/${this.companyId}/roles/${roleId}`;
    return this._httpClient.patch<any>(url, data);
  }


  // Get Modules
  getModules(): Observable<any> {
    let url = `${this.apiUrl}/modules`;
    return this._httpClient.get<any>(url);
  }

  // Create Modules
  saveModules(data: any): Observable<any> {
    let url = `${this.apiUrl}/modules`;
    return this._httpClient.post<any>(url, data);
  }

  // Update Modules
  updateModules(data: any, moduleId: any): Observable<any> {
    let url = `${this.apiUrl}/modules/${moduleId}`;
    return this._httpClient.patch<any>(url, data);
  }

  // Delete Modules
  deleteModules(moduleId: any): Observable<any> {
    let url = `${this.apiUrl}/modules/${moduleId}`;
    return this._httpClient.delete<any>(url);
  }


  // Get Modules
  dashboardStats(): Observable<any> {
    let url = `${this.apiUrl}/dashboard-stats?companyId=${this.companyId}`;
    return this._httpClient.get<any>(url);
  }

  // Get Modules
  agentCallStats(): Observable<any> {
    let url = `${this.apiUrl}/user-call-stats?companyId=${this.companyId}&userId=${this.currentUser._id}`;
    return this._httpClient.get<any>(url);
  }


}
